(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2699],{

/***/ 77287:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/app/prompt-for-chrome-extension/[id]",
      function () {
        return __webpack_require__(47537);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CopyClipboard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73400);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41997);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87109);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34386);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83321);
/* harmony import */ var _Iconify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42445);
/* harmony import */ var _hooks_useResponsive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10653);









function CopyClipboard(param) {
    var value = param.shareInputValue, inputProps = param.inputProps, onShareInputValueChange = param.onShareInputValueChange;
    var isMobile = (0,_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("down", "sm");
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_2__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        value: value,
        copied: false
    }), state = ref[0], setState = ref[1];
    var handleChange = function(event) {
        var newVal = event.target.value;
        setState({
            value: newVal,
            copied: false
        });
        if (onShareInputValueChange) {
            onShareInputValueChange(newVal);
        }
    };
    var onCopy = function() {
        setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
            copied: true
        }));
        if (state.value) {
            enqueueSnackbar("Copied!");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                fullWidth: true,
                multiline: true,
                maxRows: 15,
                value: state.value,
                onChange: handleChange,
                InputProps: {
                    endAdornment: isMobile ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        position: "end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__.CopyToClipboard, {
                            text: state.value,
                            onCopy: onCopy,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                title: "Copy",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Iconify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        icon: "eva:copy-fill",
                                        width: 24,
                                        height: 24
                                    })
                                })
                            })
                        })
                    })
                }
            }, inputProps)),
            isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__.CopyToClipboard, {
                text: state.value,
                onCopy: onCopy,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    fullWidth: true,
                    variant: "outlined",
                    sx: {
                        mt: 1
                    },
                    children: "Copy to Clipboard"
                })
            })
        ]
    });
}


/***/ }),

/***/ 50853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SkeletonImageItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88078);
// @mui


// ----------------------------------------------------------------------
function SkeletonImageItem() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        item: true,
        xs: 12,
        sm: 6,
        md: 4,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            container: true,
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 330
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 50,
                            borderRadius: 1
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 150,
                            borderRadius: 1
                        }
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 47537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ PromptsDetailPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layouts_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72575);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61582);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(99062);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(3180);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(41997);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(87109);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(67358);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(38895);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(22797);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(83321);
/* harmony import */ var _sections_landing_Shares__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29608);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42445);
/* harmony import */ var _utils_formatNumber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13162);
/* harmony import */ var _components_CopyClipboard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50107);
/* harmony import */ var _services_prompts_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76271);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25168);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var ts_enum_util__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54586);
/* harmony import */ var _hooks_useResponsive__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10653);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(31812);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _components_skeleton_SkeletonImage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50853);




















PromptsDetailPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_index__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function PromptsDetailPage(param) {
    var title = param.title, globalSetting = param.globalSetting, seoMetadataItemsCollection = param.seoMetadataItemsCollection, prompt = param.prompt;
    var isMobile = (0,_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("down", "sm");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var _language, _tone, _writingStyle, _prompt;
    var searchString = {
        language: (_language = router.query.language) !== null && _language !== void 0 ? _language : _generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .PromptSupportingLanguageMap.English */ .aNC.English,
        tone: (_tone = router.query.tone) !== null && _tone !== void 0 ? _tone : "",
        writingStyle: (_writingStyle = router.query.writingStyle) !== null && _writingStyle !== void 0 ? _writingStyle : "",
        prompt: (_prompt = router.query.prompt) !== null && _prompt !== void 0 ? _prompt : ""
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(searchString.prompt), textInput = ref[0], setTextInput = ref[1];
    var _tone1;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)((_tone1 = searchString.tone) !== null && _tone1 !== void 0 ? _tone1 : ""), tone = ref1[0], setTone = ref1[1];
    var _writingStyle1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)((_writingStyle1 = searchString.writingStyle) !== null && _writingStyle1 !== void 0 ? _writingStyle1 : ""), writingStyle = ref2[0], setWritingStyle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(searchString.language), selectLanguage = ref3[0], setSelectLanguage = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .useVisitorGeneratePromptLazyQuery */ .SDW)(), 2), visitorGeneratePromptLazyQuery = ref4[0], ref5 = ref4[1], visitorGeneratePromptLazyQueryLoading = ref5.loading;
    var ref6 = (0,_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .useVisitorFetchPromptUsagesQuery */ .DNU)({
        variables: {
            where: prompt ? {
                promptId: {
                    _like: "%".concat((0,_services_prompts_utils__WEBPACK_IMPORTED_MODULE_7__/* .decodeID */ .Eh)(prompt.id), "%")
                }
            } : {}
        }
    }), visitorFetchPromptUsagesQuery = ref6.data, visitorFetchPromptUsagesLoading = ref6.loading, visitorFetchPromptUsagesQueryRefetch = ref6.refetch;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)();
    if (!prompt) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            title: title !== null && title !== void 0 ? title : "",
            metadataItems: seoMetadataItemsCollection,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_landing_Shares__WEBPACK_IMPORTED_MODULE_3__/* .RootStyle */ .i, {
                theme: theme,
                backgroundColor: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    children: "Not Found"
                })
            })
        });
    }
    var items = [
        {
            label: "Category",
            value: prompt.category,
            icon: "material-symbols:category"
        },
        {
            label: "Views",
            value: prompt.statistics.views,
            icon: "ic:round-remove-red-eye"
        },
        {
            label: "Usages",
            value: prompt.statistics.usages,
            icon: "material-symbols:chat-bubble"
        },
        {
            label: "Likes",
            value: prompt.statistics.votes,
            icon: "mdi:like"
        }, 
    ];
    var sharedCenterSxProps = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    };
    var finalPromptString = (0,_services_prompts_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPrompt */ .Pb)({
        language: selectLanguage,
        promptString: prompt.prompt,
        userPrompt: textInput,
        writeStyle: writingStyle,
        responseTone: tone
    });
    var ref7;
    var promptUsages = (ref7 = visitorFetchPromptUsagesQuery === null || visitorFetchPromptUsagesQuery === void 0 ? void 0 : visitorFetchPromptUsagesQuery.promptUsages) !== null && ref7 !== void 0 ? ref7 : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: title !== null && title !== void 0 ? title : "",
        metadataItems: seoMetadataItemsCollection,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_landing_Shares__WEBPACK_IMPORTED_MODULE_3__/* .RootStyle */ .i, {
            theme: theme,
            backgroundColor: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        sx: {
                            mt: 5,
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                            container: true,
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                        variant: "h3",
                                        children: prompt.title
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                        variant: "h6",
                                        children: prompt.promptTeaser
                                    })
                                }),
                                items.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                            size: "medium",
                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                style: {
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        sx: {
                                                            height: 15,
                                                            width: 15,
                                                            mr: 0.5
                                                        },
                                                        icon: item.icon
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                        variant: "caption",
                                                        children: typeof item.value === "number" ? (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_5__/* .fNumber */ .FK)(item.value) : item.value
                                                    })
                                                ]
                                            })
                                        })
                                    }, item.label);
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        disablePortal: true,
                                        id: "language",
                                        value: (0,_services_prompts_utils__WEBPACK_IMPORTED_MODULE_7__/* .languageTransformer */ .uj)(selectLanguage),
                                        options: (0,ts_enum_util__WEBPACK_IMPORTED_MODULE_11__/* .$enum */ .o6)(_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .PromptSupportingLanguageMap */ .aNC).getValues().map(function(language) {
                                            return (0,_services_prompts_utils__WEBPACK_IMPORTED_MODULE_7__/* .languageTransformer */ .uj)(language);
                                        }),
                                        fullWidth: true,
                                        renderInput: function(params) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, params), {
                                                label: "Output Language",
                                                helperText: "Currently Supporting ".concat((0,ts_enum_util__WEBPACK_IMPORTED_MODULE_11__/* .$enum */ .o6)(_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .PromptSupportingLanguageMap */ .aNC).getValues().length, " languages")
                                            }));
                                        },
                                        onChange: function(_event, values) {
                                            var ref;
                                            setSelectLanguage((ref = values === null || values === void 0 ? void 0 : values.id) !== null && ref !== void 0 ? ref : _generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .PromptSupportingLanguageMap.English */ .aNC.English);
                                        },
                                        getOptionLabel: function(option) {
                                            return option.label;
                                        },
                                        isOptionEqualToValue: function(option, value) {
                                            return option.id === value.id;
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        label: "Prompt",
                                        helperText: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    variant: "body2",
                                                    children: "Enter your prompt here, it'll be used as a prompt for Open AI"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    variant: "body2",
                                                    children: [
                                                        "Prompt Hint: ",
                                                        prompt.promptHint
                                                    ]
                                                })
                                            ]
                                        }),
                                        value: textInput,
                                        onChange: function(e) {
                                            setTextInput(e.target.value);
                                        },
                                        InputProps: {
                                            endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                position: "end",
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                onClick: function() {
                                                    setTextInput("");
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    icon: "system-uicons:reset"
                                                })
                                            })
                                        },
                                        fullWidth: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    icon: "eva:arrow-ios-downward-fill",
                                                    width: 20,
                                                    height: 20
                                                }),
                                                "aria-controls": "panel2a-content",
                                                id: "panel2a-header",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    children: "Click me to see advance options (Premium Only)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                                    container: true,
                                                    spacing: 4,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                                            item: true,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                                                disablePortal: true,
                                                                freeSolo: true,
                                                                id: "Tone",
                                                                inputValue: tone,
                                                                options: (0,ts_enum_util__WEBPACK_IMPORTED_MODULE_11__/* .$enum */ .o6)(_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .ResponseTone */ .sX_).getValues(),
                                                                fullWidth: true,
                                                                renderInput: function(params) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, params), {
                                                                        label: "Tone you prefer",
                                                                        helperText: "Choose a tone for the response you prefer"
                                                                    }));
                                                                },
                                                                onInputChange: function(_event, values) {
                                                                    return setTone(values);
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                                            item: true,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                                                disablePortal: true,
                                                                freeSolo: true,
                                                                id: "WritingStyle",
                                                                inputValue: writingStyle,
                                                                options: (0,ts_enum_util__WEBPACK_IMPORTED_MODULE_11__/* .$enum */ .o6)(_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .WritingStyle */ .Kid).getValues(),
                                                                fullWidth: true,
                                                                renderInput: function(params) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({}, params), {
                                                                        label: "Writing Style",
                                                                        helperText: "Choose a writing style for the response you prefer"
                                                                    }));
                                                                },
                                                                onInputChange: function(_event, values) {
                                                                    return setWritingStyle(values);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: textInput && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CopyClipboard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        shareInputValue: finalPromptString
                                    }, textInput)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: textInput && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                        container: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                            item: true,
                                            xs: 12,
                                            sx: sharedCenterSxProps,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                                target: "_blank",
                                                variant: isMobile ? "text" : "outlined",
                                                fullWidth: true,
                                                href: "https://chat.openai.com/",
                                                children: [
                                                    "Go to Open AI Page",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        sx: {
                                                            ml: 1
                                                        },
                                                        icon: "material-symbols:arrow-right",
                                                        width: 25,
                                                        height: 25
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: textInput && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        variant: "contained",
                                        fullWidth: true,
                                        loading: visitorGeneratePromptLazyQueryLoading,
                                        onClick: function() {
                                            visitorGeneratePromptLazyQuery({
                                                variables: {
                                                    promptId: (0,_services_prompts_utils__WEBPACK_IMPORTED_MODULE_7__/* .decodeID */ .Eh)(prompt.id),
                                                    language: selectLanguage,
                                                    prompt: textInput
                                                },
                                                notifyOnNetworkStatusChange: true,
                                                fetchPolicy: "no-cache",
                                                onCompleted: function(data) {
                                                    var ref;
                                                    visitorFetchPromptUsagesQueryRefetch();
                                                    console.log("data", (ref = data.generatePrompt.createResponse) === null || ref === void 0 ? void 0 : ref.choices);
                                                }
                                            });
                                        },
                                        children: "Magic"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                        container: true,
                        spacing: 3,
                        sx: {
                            mt: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    variant: "h6",
                                    children: "User Input & Output"
                                })
                            }),
                            visitorFetchPromptUsagesLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton_SkeletonImage__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}) : promptUsages.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    children: "No Record Found"
                                })
                            }) : visitorFetchPromptUsagesQuery === null || visitorFetchPromptUsagesQuery === void 0 ? void 0 : visitorFetchPromptUsagesQuery.promptUsages.map(function(promptUsage) {
                                var ref, ref1;
                                var response = promptUsage.response;
                                var ref2;
                                var output = ((ref2 = response === null || response === void 0 ? void 0 : (ref = response.choices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.text) !== null && ref2 !== void 0 ? ref2 : "").trim();
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 6,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        sx: {
                                            mt: 5,
                                            p: 5
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                            container: true,
                                            spacing: 3,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                            variant: "h6",
                                                            children: "User Input"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CopyClipboard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            shareInputValue: promptUsage.userPrompt
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                            variant: "h6",
                                                            children: "User Output"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CopyClipboard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            shareInputValue: output
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                        size: "medium",
                                                        label: "Created ".concat(moment__WEBPACK_IMPORTED_MODULE_12___default()(promptUsage.createdAt).fromNow())
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, promptUsage.id);
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 13162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ fNumber; },
/* harmony export */   "e_": function() { return /* binding */ fCurrency; }
/* harmony export */ });
/* unused harmony exports fPercent, fShortenNumber, fData */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);

// ----------------------------------------------------------------------
function fCurrency(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}
function fPercent(number) {
    return numeral(number / 100).format("0.0%");
}
function fNumber(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format();
}
function fShortenNumber(number) {
    return numeral(number).format("0.00a").replace(".00", "");
}
function fData(number) {
    return numeral(number).format("0.0 b");
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,6547,513,9694,1664,9463,7952,4894,1997,2077,3895,6993,7501,8424,6755,3907,2575,69,9774,2888,179], function() { return __webpack_exec__(77287); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);